import { render, staticRenderFns } from "./TranceShowTablet.vue?vue&type=template&id=663aeb2e&"
var script = {}
import style0 from "./TranceShowTablet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports